import { h, Component } from 'preact'
import Router from 'preact-router'
import tdlib, { TdEvent } from './utils/tdlib'
import { AuthState } from './types/auth'
import { ROUTE } from './constants/routes'
import Error from './pages/Error'
import Auth from './pages/Auth'
import Messenger from './pages/Messenger'

interface iState {
  isLogged: boolean
}

class Routing extends Component<{}, iState> {
  state = {
    isLogged: false
  }

  async componentDidMount () {
    await tdlib.subscribe(
      'updateAuthorizationState',
      ({ authorization_state }: TdEvent) => {

        switch (authorization_state['@type']) {
          case AuthState.ready:
            return this.setLoggedStatus(true)
          default: {
            return this.setLoggedStatus(false)
          }
        }
      }
    )
  }

  setLoggedStatus = (isLogged: boolean) => {
    this.setState({
      isLogged
    })
  }

  render () {
    const { isLogged } = this.state

    return (
      <Router>
        {isLogged && (
          <Messenger path={ROUTE.HOME}/>
        )}

        {!isLogged && (
          <Auth path={ROUTE.HOME}/>
        )}

        <Error
          code={400}
          default
        />
      </Router>
    )
  }
}

export default Routing
